import { RootState } from '../../../root-saga/root-state';
import { initialState } from './index';
import { createSelector } from '@reduxjs/toolkit';

const selectDomain = (state: RootState) => state['users'] || initialState;

export const selectUsers = createSelector([selectDomain], (state) => state.users);
export const selectUsersTotal = createSelector([selectDomain], (state) => state.total);
export const selectUsersIsLoading = createSelector([selectDomain], (state) => state.isLoading);
export const selectUsersError = createSelector([selectDomain], (state) => state.error);

